import gql from 'graphql-tag';

export default gql`
  mutation RefreshSignedExternalUrl($mediaId: UUID!) {
    refreshSignedExternalUrl(mediaId: $mediaId)
  }
`;
